import React from "react";

const GernalSvg = ({className}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.75 16.5H17.25"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.835 16.5076V13.1626"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8502 8.16748C13.9352 8.16748 13.2002 8.90249 13.2002 9.81749V11.52C13.2002 12.435 13.9352 13.17 14.8502 13.17C15.7652 13.17 16.5002 12.435 16.5002 11.52V9.81749C16.5002 8.90249 15.7652 8.16748 14.8502 8.16748Z"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5752 16.4998V4.52234C1.5752 3.01484 2.32523 2.25732 3.81773 2.25732H8.49022C9.98272 2.25732 10.7252 3.01484 10.7252 4.52234V16.4998"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.3501 6.1875H8.06261"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.3501 9H8.06261"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.1875 16.5V13.6875"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GernalSvg;
